import { FaSortAmountDownAlt } from 'react-icons/fa'

import styles from '../styles/SortButton.module.css'

export default function SortButton(props){
  return(
    <div
      className={props.active ? [styles.sort_button, styles.active].join(' ') : styles.sort_button}
      onClick={props.clickHandler}
    ><FaSortAmountDownAlt/> {props.text}</div>
  )
}
